import React, {Component} from 'react';
import {connect, useSelector} from 'react-redux';
import autobind from 'autobind-decorator';
import {setEditingCategoryInfo, updateCateghoryInfo, updateCategoryVisibility} from '../../../actions/category';
import SimpleDialog from "../../common/SimpleDialog";
import TSelectForm from "../../common/TSelectForm";
import ImageUploadButton from "../../common/ImageUploadButton";
import * as CategoryVisibility from "../../../constants/category/CategoryVisibility";
import classnames from 'classnames';
import {findCategoryNode} from '../Utils';


function ApplyChildButton(props) {
  const {id, checked, onChange} = props;

  return (
    <div className="check_blog">
      <input type="checkbox" id={id} className="inp_check" checked={checked} onChange={onChange}/>
      <label htmlFor={id} className="lab_check">
        <span className="ico_blog ico_checkbox">{checked ? '선택 됨' : '선택 안됨'}</span>
        <span className="txt_check">하위 카테고리에 함께 적용합니다.</span>
      </label>
    </div>
  );
}

function CategoryInfoItem(props) {
  const {title, children} = props;
  return (
    <dl className="info_layer_cont">
      <dt>{title}</dt>
      <dd>
        {children}
      </dd>
    </dl>
  );
}

/**
 * 카테고리 공개/비공개 설정 BOX
 * @param props
 * props.parentCategory                 : 부모카테고리
 * props.visibility                     : 선택된 카테고리 Visibility
 * props.onChangeVisibility             : 카테고리 Visibility 변경 Handler
 * props.isOpenCategoryItemsVisible     : 카테고리 Select box layer 노출 여부
 * props.onChangeCategoryItemsVisible   : 카테고리 Select box layer 노출 변경 Handler
 * @returns {*}
 * @constructor
 */
function CategoryVisibilityBox(props) {
  const {PUBLIC, PRIVATE, List, getLabelByVisibility} = CategoryVisibility;
  const {visibility, onChangeVisibility, isOpenCategoryItemsVisible, onChangeCategoryItemsVisible, parentCategory} = props;
  const parentVisibility = (parentCategory.visibility === undefined) ? PUBLIC : parentCategory.visibility;
  const isPrivateParent = PRIVATE == parentVisibility;

  return <dl className="info_layer_cont info_layer_type1">
    <dt>공개 설정</dt>
    <dd>
      <div className="wrap_set">
        <div className="item_set item_sub">
          <div className={classnames("opt_set opt_category", {"opt_open": isOpenCategoryItemsVisible})}>
            <button type="button" className="btn_opt" disabled={isPrivateParent} onClick={() => onChangeCategoryItemsVisible(true)}>
              <span className="txt_ellip">{getLabelByVisibility(visibility)}</span><span className="ico_blog ico_open"></span>
            </button>
            <div className="layer_opt">
              {List.map((value) =>
                <label className="lab_set on" key={value} onClick={() => onChangeVisibility(value)}>
                  <input type="radio" name="category" className="inp_set"/>
                  <span className={classnames({"txt_set": value == visibility}, "txt_ellip")}>{getLabelByVisibility(value)}</span>
                </label>
              )}
              <button type="button" className="btn_close"><span className="ico_blog"></span></button>
            </div>
          </div>
        </div>
      </div>
    </dd>
  </dl>
}


function ListstyleForm({liststyle, onChange}) {
  const liststyles = useSelector(state => state.blog.skinInfo.liststyle && JSON.parse(state.blog.skinInfo.liststyle))
  if (!liststyles || liststyles.length == 0) {
    return(
      <dl className="info_layer_cont info_layer_type1">
        <dt>목록 스타일</dt>
        <dd>
          <div className="wrap_set">
            <div className="item_set item_sub">
              <div className="opt_set opt_category">
                <button type="button" className="btn_opt" disabled>
                  <span className="txt_ellip">설정 불가 스킨</span>
                  <span className="ico_blog ico_open" />
                </button>
                <div className="layer_opt">
                  <label className="lab_set">
                    <input type="radio" name="category" className="inp_set"/>
                    <span className="txt_set txt_ellip">하위 카테고리명</span>
                  </label>
                  <button type="button" className="btn_close">
                    <span className="ico_blog" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </dd>
      </dl>
    )
  } else {

    const items = liststyles.concat([{label: "기본 스타일 유지", value: "use-blog-liststyle"}]);

    return (
      <dl className="info_layer_cont info_layer_type1">
        <dt>목록 스타일</dt>
        <dd>
          <div className="wrap_set">
            <div className="item_set item_sub">
              <TSelectForm
                className={"opt_set opt_category"}
                items={items}
                selected={liststyle}
                onSelect={onChange}
              />
            </div>
          </div>
        </dd>
      </dl>
    )
  }

}


@connect(state => ({
  category: state.category.infoEditCategory,
  skinDefaultValues: state.blog.skinInfo.default && JSON.parse(state.blog.skinInfo.default),
  currentPath: state.category.treeHelper.indexPath,
  categoryTree: state.category.categoryTree,
}), dispatch => ({
  handleCloseCategoryInfoLayer() {
    dispatch(setEditingCategoryInfo(null))
  },
  handleUpdateCategoryInfo(categoryId, categoryInfo, applyAllImage, applyAllDescription) {
    dispatch(updateCateghoryInfo(categoryId, categoryInfo, applyAllImage, applyAllDescription))
  },
  handleUpdateCategoryVisibility(categoryId, visibility) {
    dispatch(updateCategoryVisibility(categoryId, visibility))
  }
}))
class CategoryInfoLayer extends Component {

  constructor(props) {
    super(props);
    const {skinDefaultValues, currentPath, category, categoryTree} = props;
    const {liststyle, image, description} = props.category.categoryInfo;
    const parentCategory = findCategoryNode(category.parent, currentPath, categoryTree);

    this.state = {
      liststyle: liststyle || skinDefaultValues.liststyle,
      image: image,
      applyAllImage: false,
      description: description || '',
      applyAllDescription: false,
      visibility: this.initVisibility(category.visibility, parentCategory),                   // 카테고리 공개/비공개 선택 item
      isOpenCategoryItemsVisible: false,                                                      // 카테고리 Select box items 노출여부의 toggle 변수
      parentCategory: parentCategory                                                          // 부모카테고리 정보
    };
  }


  @autobind
  initVisibility(visibility, parentCategory) {
    const {PRIVATE} = CategoryVisibility;

    // 부모카테고리가 Private이면 자식은 무조건 Privte으로 사용한다.
    return (parentCategory && parentCategory.visibility == PRIVATE)
      ? PRIVATE
      : visibility;
  }

  @autobind
  handleSubmit(e) {
    const {category, handleUpdateCategoryInfo, handleUpdateCategoryVisibility} = this.props;
    const {liststyle, image, applyAllImage, description, applyAllDescription, visibility} = this.state;
    e.preventDefault();

    handleUpdateCategoryInfo(category.id, {liststyle, image, description}, applyAllImage, applyAllDescription);
    handleUpdateCategoryVisibility(category.id, visibility);
    return false;
  }

  @autobind
  handleChangeApplyAllImage(e) {
    this.setState({
      applyAllImage: !this.state.applyAllImage
    });
  }

  @autobind
  handleChangeApplyAllDescription(e) {
    this.setState({
      applyAllDescription: !this.state.applyAllDescription
    });
  }

  @autobind
  handleChangeDescription(e) {
    const value = e.target.value;
    this.setState({
      description: value.substring(0, 100)
    });
  }

  @autobind
  handleChangeImage(value) {
    this.setState({
      image: value
    });
  }

  @autobind
  handleChangeListStyle(item, idx) {
    this.setState({
      liststyle: item.value
    });
  }

  /**
   * 카테고리 Visibility 변경 Handler
   * @param visibility
   */
  @autobind
  handleChangeVisibility(visibility) {
    this.setState({
      visibility: visibility
    });

    this.handleChangeCategoryItemsVisible(false);
  }

  /**
   * 카테고리 Select box layer 노출여부 변경 handler
   */
  @autobind
  handleChangeCategoryItemsVisible(isOpen) {
    this.setState({
      isOpenCategoryItemsVisible: isOpen
    });
  }

  checkValidated() {
    const {category} = this.props;
    const {liststyle, image, applyAllImage, description, applyAllDescription, visibility} = this.state;
    const {categoryInfo} = category;

    return applyAllImage
      || applyAllDescription
      || categoryInfo.image != image
      || categoryInfo.description != description
      || categoryInfo.liststyle != liststyle
      || category.visibility != visibility
  }

  render() {
    const {category, handleCloseCategoryInfoLayer} = this.props;
    const {liststyle, image, applyAllImage, description, applyAllDescription, visibility, isOpenCategoryItemsVisible, parentCategory} = this.state;
    const layerStyle = {
      position: 'fixed',
      top: '50%',
      left: '50%',
      margin: '-273px 0 0 0'
    };

    const hasChildren = category.children.length > 0;

    return (
      <SimpleDialog
        title={`'${category.name}' 관리`}
        className="inner_blog_layer5"
        style={layerStyle}
        validated={this.checkValidated()}
        onClose={handleCloseCategoryInfoLayer}
        onSubmit={this.handleSubmit}
      >

        <CategoryVisibilityBox
          parentCategory={parentCategory}
          visibility={visibility}
          onChangeVisibility={this.handleChangeVisibility}
          isOpenCategoryItemsVisible={isOpenCategoryItemsVisible}
          onChangeCategoryItemsVisible={this.handleChangeCategoryItemsVisible}
        />

        <ListstyleForm
          liststyle={liststyle}
          onChange={this.handleChangeListStyle}
        />

        <div className="radio_cate">
          <p className="txt_popup">스킨에 따라 출력되지 않을 수 있습니다.</p>

          <CategoryInfoItem title='대표 이미지'>
            <ImageUploadButton value={image} onChange={this.handleChangeImage}/>
          </CategoryInfoItem>
          {hasChildren &&
            <ApplyChildButton
              id="applyAllImage"
              checked={applyAllImage}
              onChange={this.handleChangeApplyAllImage}
            />
          }

          <CategoryInfoItem title='카테고리 소개'>
            <textarea className="tf_blog" value={description} onChange={this.handleChangeDescription}/>
            <span className="count_total">
            <span className="screen_out">글자수</span>
            <span className="txt_num">{description.length}</span> / 100
            </span>
          </CategoryInfoItem>
          {hasChildren &&
            <ApplyChildButton
              id={'applyAllDescription'}
              checked={applyAllDescription}
              onChange={this.handleChangeApplyAllDescription}
            />
          }
        </div>
      </SimpleDialog>
    );
  }
}

export default CategoryInfoLayer
